export const formatAmountWrapper = (currencyCodeMap, currencyFormatter, currency) => (amount, displayString) => {
    const currencyCode = currencyCodeMap[currency];
    return amount > 0 && typeof currencyCode !== "undefined"
        ? `${displayString} ${currencyFormatter(amount, currency, currencyCode.locale, currencyCode.currencyDisplay)}`
        : "";
};
//# sourceMappingURL=formatAmount.js.map